
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Sarah Johnson',
      location: 'Downtown District',
      rating: 5,
      text: 'KAILE BRIGHT has been cleaning our home for over a year now. They are always punctual, thorough, and professional. I love coming home to a spotless house!',
      image: 'https://public.readdy.ai/ai/img_res/56b3b6b5f30a097820b0064c761f4b2b.jpg'
    },
    {
      name: 'Michael Chen',
      location: 'Riverside Heights',
      rating: 5,
      text: 'Excellent service! The team did an amazing deep clean when we moved in. Every corner was spotless. Highly recommend their move-in cleaning service.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20confident%20Asian%20man%20in%20his%2030s%2C%20wearing%20business%20casual%20attire%2C%20smiling%20professionally%2C%20clean%20background%2C%20trustworthy%20appearance&width=80&height=80&seq=testimonial-2&orientation=squarish'
    },
    {
      name: 'Emily Rodriguez',
      location: 'Garden Valley',
      rating: 5,
      text: 'As a busy mom of three, KAILE BRIGHT is a lifesaver! Their eco-friendly products give me peace of mind, and the quality is consistently excellent.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20friendly%20Hispanic%20woman%20with%20dark%20hair%2C%20warm%20smile%2C%20professional%20appearance%2C%20clean%20background%2C%20approachable%20and%20trustworthy&width=80&height=80&seq=testimonial-3&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-xl text-gray-600">
            Don't just take our word for it - hear from our satisfied customers
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-center mb-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h3 className="font-semibold text-gray-900">{testimonial.name}</h3>
                  <p className="text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              
              <p className="text-gray-700 italic">"{testimonial.text}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
